<template>
  <el-dialog
    title="选择订单商品"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <div class="query-form">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-input
            v-model="chooseStoreOrderCartInfo.orderId"
            placeholder="输入订单编号"
            clearable
            @keyup.enter.native="queryProducts">
          </el-input>
        </el-col>
        <el-col :span="12">
          <el-input
            v-model="chooseStoreOrderCartInfo._currentProductName"
            placeholder="输入商品信息名称/条形码"
            clearable
            @keyup.enter.native="queryProducts">
            <el-button slot="append" type="primary" @click="queryProducts">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div class="table-container" style="margin-top: 15px;">
      <el-table
        :data="chooseStoreOrderCartInfo.products"
        border
        stripe
        style="width: 100%">
        <el-table-column prop="cartType" label="类型" align="center" width="80">
          <template slot-scope="scope">
            {{ scope.row.cartType == '3307' ? '服务' : '商品' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
        <el-table-column prop="personName" label="用户" align="center"></el-table-column>
        <el-table-column prop="cartNum" label="购买数量" align="center"></el-table-column>
        <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="price" label="单价" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="chooseStoreOrderCart(scope.row)">
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="chooseStoreOrderCartInfo.total > 0"
        class="pagination"
        layout="prev, pager, next"
        :total="chooseStoreOrderCartInfo.total"
        :page-size="chooseStoreOrderCartInfo.row"
        :current-page="chooseStoreOrderCartInfo.page"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryStoreOrderCart } from '@/api/goods/storeOrderCartDetail/storeOrderCartDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseStoreOrderCart',
  data() {
    return {
      dialogVisible: false,
      chooseStoreOrderCartInfo: {
        orderId: '',
        _currentProductName: '',
        products: [],
        page: 1,
        row: 10,
        total: 0,
        shopId: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.chooseStoreOrderCartInfo.shopId = getShopId()
      this.queryProducts()
    },
    handleClose() {
      this.chooseStoreOrderCartInfo.orderId = ''
      this.chooseStoreOrderCartInfo._currentProductName = ''
      this.chooseStoreOrderCartInfo.products = []
      this.chooseStoreOrderCartInfo.page = 1
      this.chooseStoreOrderCartInfo.total = 0
    },
    async queryProducts() {
      try {
        const params = {
          page: this.chooseStoreOrderCartInfo.page,
          row: this.chooseStoreOrderCartInfo.row,
          shopId: this.chooseStoreOrderCartInfo.shopId
        }
        
        if (this.chooseStoreOrderCartInfo.orderId) {
          params.orderId = this.chooseStoreOrderCartInfo.orderId.trim()
        }
        
        if (this.chooseStoreOrderCartInfo._currentProductName) {
          params.prodNameLike = this.chooseStoreOrderCartInfo._currentProductName.trim()
        }
        
        const res = await queryStoreOrderCart(params)
        this.chooseStoreOrderCartInfo.products = res.data || []
        this.chooseStoreOrderCartInfo.total = res.total || 0
      } catch (error) {
        console.error('查询订单商品失败:', error)
        this.$message.error('查询订单商品失败')
        this.chooseStoreOrderCartInfo.products = []
        this.chooseStoreOrderCartInfo.total = 0
      }
    },
    chooseStoreOrderCart(product) {
      // 单选模式：直接触发事件并关闭对话框
      this.$emit('chooseStoreOrderCart', [product])
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.chooseStoreOrderCartInfo.page = val
      this.queryProducts()
    }
  }
}
</script>

<style scoped>
.query-form {
  margin-bottom: 15px;
}

.table-container {
  max-height: 500px;
  overflow-y: auto;
}

.pagination {
  margin-top: 15px;
  text-align: right;
}

.dialog-footer {
  text-align: center;
}
</style>